'use client';
import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

function getTimeUntilSunday(): { days: number; hours: number; minutes: number; seconds: number } {
  const now = new Date();
  const nextSunday = new Date(now);
  nextSunday.setUTCDate(now.getUTCDate() + (7 - now.getUTCDay()) % 7 || 7);
  nextSunday.setUTCHours(0, 0, 0, 0);
  const diff = nextSunday.getTime() - now.getTime();
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { days, hours, minutes, seconds };
}

export default function WeeklyCountdown() {
  const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    setTime(getTimeUntilSunday());
    const interval = setInterval(() => {
      setTime(getTimeUntilSunday());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const pad = (n: number) => String(n).padStart(2, '0');

  return (
    <div className="flex items-center gap-3 px-4 py-3 rounded-lg border border-border bg-card">
      <Clock size={16} className="text-primary flex-shrink-0" />
      <div>
        <div className="text-xs text-muted-foreground mb-1 font-mono uppercase tracking-wide">Resets in</div>
        <div className="flex items-center gap-1.5 font-mono font-bold text-primary animate-countdown">
          <span className="text-xl">{pad(time.days)}</span>
          <span className="text-muted-foreground text-sm">d</span>
          <span className="text-xl">{pad(time.hours)}</span>
          <span className="text-muted-foreground text-sm">h</span>
          <span className="text-xl">{pad(time.minutes)}</span>
          <span className="text-muted-foreground text-sm">m</span>
          <span className="text-xl">{pad(time.seconds)}</span>
          <span className="text-muted-foreground text-sm">s</span>
        </div>
      </div>
    </div>
  );
}